import Vue from 'vue'
import Router from 'vue-router'
import store from "./store/store";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: '/etelrendeles',
    routes: [
        {
            path: '*',
            component: () => import('./views/public/order.vue')
        },
        {
            path: '/',
            component: () => import('./views/public/order.vue')
        },
        {
            path: '/rendeles/:ref',
            component: () => import('./views/public/orderResponse.vue')
        },
        {
            path: '/rendeles',
            component: () => import('./views/public/order.vue'),
        },
        {
            path: '/admin',
            component: () => import('./views/admin/login.vue'),
        },
        {
            path: '/dashboard',
            component: () => import('./layout/full/MainContainer.vue'),
            meta: {
                requiresAuth: true
            },
            children: [
                {
                    path: '/dashboard/items',
                    name: 'items',
                    component: () => import('./views/admin/items'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/dashboard/addons',
                    name: 'addons',
                    component: () => import('./views/admin/addons'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/dashboard/categories',
                    name: 'categories',
                    component: () => import('./views/admin/categories'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/dashboard/labels',
                    name: 'labels',
                    component: () => import('./views/admin/labels'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/dashboard/shippings',
                    name: 'shippings',
                    component: () => import('./views/admin/shippings'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/dashboard/payments',
                    name: 'payments',
                    component: () => import('./views/admin/payments'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/dashboard/menus',
                    name: 'menus',
                    component: () => import('./views/admin/menus'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/dashboard/dailymenu',
                    name: 'daily_menu',
                    component: () => import('./views/admin/dailymenu'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/dashboard/itemoptions',
                    name: 'item_options',
                    component: () => import('./views/admin/item_options'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/dashboard/orderoptions',
                    name: 'order_options',
                    component: () => import('./views/admin/order_options'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/dashboard/dailymenuitems',
                    name: 'daily_menu_item',
                    component: () => import('./views/admin/dailymenuitems'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/dashboard/orders',
                    name: 'orders',
                    component: () => import('./views/admin/orders'),
                    meta: {
                        requiresAuth: true
                    }
                },
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        let loggedIn = store.getters['loggedIn']
        if (loggedIn) {
            next();
            return;
        }
        store.commit('logoutUser');
        next('/admin');
    } else {
        next();
    }
})

export default router;